
export const getThreeComments = state => state.comments.comments;

export const getThread = state => state.comments.thread;

export const getThreads = state => state.comments.threads.list;

export const getTotalThreads = state => state.comments.threads.total;
